import { EPromotionTypes } from "../../store/store.interface";

export const cartBundlePayload = (data: any, email: string) => {
  const { name, startDate, endDate, bundleType, bundleOffering, discountValue,
    bundleQuantity, discountQuantity, descriptionAr, shortTextAr, longTextAr,
    descriptionEn, shortTextEn, LongTextEn, itemInfo, posId,
  } = data

  const isOffOn2ndUnit = bundleOffering === "OFF ON 2ND UNIT"

  return {
    name: name,
    createdBy: email,
    description: name,
    startDate: startDate,
    endDate: endDate,
    offer: {
      promotion: {
        type: "DISCOUNT",
        discountType: isOffOn2ndUnit ? "PERCENTAGE" : "BXGYFREE",
        amount: isOffOn2ndUnit ? Number(discountValue) : 100,
      },
      bundleInfo: {
        mixAndMatch: bundleType === "MIX AND MATCH",
        quantity: bundleQuantity,
        discountQuantity: discountQuantity,
        text: {
          ar: {
            badge: "عرض",
            description: descriptionAr,
            shortText: shortTextAr,
            longText: longTextAr,
            firstTnc: longTextAr,
            secondTnc: longTextAr,
            offerText: descriptionAr,
          },
          en: {
            badge: "BUNDLE",
            description: descriptionEn,
            shortText: shortTextEn,
            longText: LongTextEn,
            firstTnc: LongTextEn,
            secondTnc: LongTextEn,
            offerText: descriptionEn,
          }
        }
      },
      posId,
    },
    itemInfo: {
      itemList: itemInfo
    }
  }
}

export const flatBundleCampaign = (data: any) => {
  const { name, offer:
    { bundleInfo: { text, mixAndMatch, quantity },
      promotion: { discountType, amount },
      posId,
    },
    startDate, endDate, campaignId, itemInfo
  } = data

  return {
    name: name,
    descriptionEn: text.en.description,
    descriptionAr: text.ar.description,
    shortTextEn: text.en.shortText,
    shortTextAr: text.ar.shortText,
    LongTextEn: text.en.longText,
    longTextAr: text.ar.longText,
    startDate: startDate,
    endDate: endDate,
    bundleType: mixAndMatch ? "MIX AND MATCH" : "SINGLE ITEM BUNDLE",
    bundleOffering: discountType === "BXGYFREE" ? "BXGY" : "OFF ON 2ND UNIT",
    bundleQuantity: quantity,
    itemInfo: itemInfo.itemList,
    campaignId: campaignId,
    posId: posId,
    ...(discountType === "PERCENTAGE" && {
      discountValue: String(amount)
    })
  }
}

const freeGiftPayload = (data: any, email: string) => {
  const { name, startDate, endDate, description, shortTextAr, 
    shortTextEn, parentProduct, giftProduct, includedPosId, excludedPosId,
  } = data

  return {
    name: name,
    createdBy: email,
    description: description,
    startDate: startDate,
    endDate: endDate,
    offer: {
      promotion:{
        type: "FREE_GIFT",
      },
      posInfoList: [
        {
          op: includedPosId ? "IN" : "NOTIN",
          value: includedPosId || excludedPosId,
        }
      ],
      collections: [
        {
          type: "parent",
          sku: parentProduct,
          text: {
            ar: {
              shortText: shortTextAr,
            },
            en: {
              shortText: shortTextEn,
            }
          }
        },
        {
          type: "freeGift",
          sku: giftProduct,
        }
      ]
    },
  };
}

export const flatFreeGiftCampaign = (data: any) => {
  const {
    name,
    description,
    startDate,
    endDate,
    campaignId,
    offer: { posInfoList = [], collections = [] },
  } = data;

  const posInfo = posInfoList?.[0];

  const parentCollection = collections?.find(
    (item: any) => item.type === "parent",
  );

  const giftCollection = collections?.find(
    (item: any) => item.type === "freeGift",
  );

  return {
    name,
    description,
    startDate,
    endDate,
    shortTextAr: parentCollection?.text?.ar?.shortText,
    shortTextEn: parentCollection?.text?.en?.shortText,
    parentProduct: parentCollection?.sku || [],
    giftProduct: giftCollection?.sku || [],

    ...(posInfo?.op?.toLowerCase() === "in"
      ? { includedPosId: posInfo?.value }
      : { excludedPosId: posInfo?.value }),
    campaignId,
  };
};

export const getBundleCampaignPayload = (data: any, email: string) => {
  const { type } = data;

  if ([EPromotionTypes.FREE_GIFT].includes(type?.toUpperCase())) {
    return freeGiftPayload(data, email);
  }
  return cartBundlePayload(data, email);
};

export const normalizeBundleFormData = (data: any) => {
  const { type } = data;

  if ([EPromotionTypes.FREE_GIFT].includes(type?.toUpperCase())) {
    return flatFreeGiftCampaign(data);
  }
  return flatBundleCampaign(data);
};
